if ( typeof VideoBackgroundElement !== 'function' ) {

  class VideoBackgroundElement extends HTMLElement {
    constructor(){
      super();

      this._eventSuccess = new Event('success');
      this._eventFail = new Event('fail');

      const video = this.querySelector('video');
      if (!video) return;

      const markLoaded = () => {
        if (!this.classList.contains('loaded')) {
          this.classList.add('loaded');
          this.dispatchEvent(this._eventSuccess);
        }
      };

      const loadSources = () => {
        this.querySelectorAll('video source[data-src]').forEach(src => {
          src.setAttribute('src', src.getAttribute('data-src'));
          src.removeAttribute('data-src');
        });
        // autoplay kompatibilitás
        video.muted = true;
        video.playsInline = true;
        video.setAttribute('preload', 'auto');
        video.load();

        const tryPlay = () => {
          const p = video.play();
          if (p && typeof p.catch === 'function') p.catch(()=>{ /* ignore */ });
        };

        if (video.readyState >= 2) {
          tryPlay();
        } else {
          video.addEventListener('loadeddata', tryPlay, { once:true });
          video.addEventListener('canplaythrough', tryPlay, { once:true });
        }
      };

      // események
      video.addEventListener('error', () => { this.switchFallback(); });
      video.addEventListener('stalled', () => { if (!this.classList.contains('loaded')) this.switchFallback(); });
      video.addEventListener('playing', markLoaded, { once:true });

      // IO callback – TISZTA logika
      const handleIntersection = (entries, observer) => {
        const entry  = entries[0];
        if (!entry.isIntersecting) return;

        const target = entry.target;
        const isSelf = String(target.tagName).toUpperCase() === 'VIDEO-BACKGROUND-ELEMENT';
        const host   = isSelf ? target : target.querySelector('video-background-element');

        if (!host || host.classList.contains('loaded')) {
          observer.unobserve(target);
          return;
        }

        loadSources();
        observer.unobserve(target);
      };

      const inFirstViewportOrNear =
        this.getBoundingClientRect().top < window.innerHeight * 0.9 ||
        (this.parentElement && this.parentElement.getBoundingClientRect().top < window.innerHeight * 0.9);

      if (inFirstViewportOrNear) {
        // Azonnal töltsön, hogy a 2. pozícióban lévő hős is készen álljon
        loadSources();
      } else {
        const ioOpts = { root: null, rootMargin: '0px 0px 400px 0px', threshold: 0.01 };
        const io = new IntersectionObserver(handleIntersection, ioOpts);
        io.observe(this);
        if (this.parentElement) io.observe(this.parentElement);
      }
    }

    switchFallback(){
      const fallback = this.parentElement?.querySelector(`[data-video-background-fallback][data-id="${this.dataset.id}"]`);
      if ( fallback ) {
        fallback.append(fallback.querySelector('template').content.cloneNode(true));
        // kényszerítsd a lazy image-eket is
        const img = fallback.querySelector('img');
        if (img) img.setAttribute('srcset', img.getAttribute('srcset'));
      }
      this.dispatchEvent(this._eventFail);
    }
  }

  if ( typeof customElements.get('video-background-element') === 'undefined' ) {
    customElements.define('video-background-element', VideoBackgroundElement);
  }
}

// Shopify section reload fix – maradhat, de bővítve play()-jel
document.addEventListener('shopify:section:load', e=>{
  if ( e.target.classList.contains('mount-video-background') ) {
    setTimeout(()=>{
      e.target.querySelectorAll('video-background-element').forEach(elm=>{
        elm.querySelectorAll('source[data-src]').forEach(source=>{
          if (source.dataset.src) {
            source.src = source.dataset.src;
            source.removeAttribute('data-src');
          }
        });
        const v = elm.querySelector('video');
        if (!v) return;
        v.muted = true; v.playsInline = true; v.setAttribute('preload','auto');
        v.load();
        const p = v.play();
        if (p && typeof p.catch === 'function') p.catch(()=>{});
      });
    }, 500);
  }
});
